import { onDeepLink } from '@/shared/lib/platform/deepLinks'
import { handleCallback } from '@/shared/lib/oauthPkce'

/** URLs de retorno OAuth (ITI CAS / VIDaaS) capturadas via App Links no Android. */
export const isOAuthCallbackUrl = (url: URL): boolean => {
  const path = url.pathname
  return (
    path.includes('/oauth/iti-cas/callback') ||
    path.includes('/auth/iti/callback') ||
    path.includes('/oauth/vidaas/callback') ||
    path.includes('/auth/vidaas/callback')
  )
}

/** Registra dispatcher de deep links nativos (no-op na PWA). */
export const registerNativeOAuthDeepLinks = (): (() => void) =>
  onDeepLink((url) => {
    if (!isOAuthCallbackUrl(url)) {
      return
    }
    void handleCallback(url)
  })
